// -----------------------------------------------------------------------------
// Slider on the page itinerary
// -----------------------------------------------------------------------------

// Slider
function itinerarySlider(el) {
  el.slick({
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    focusOnSelect: true,
  });
}
